import { ApiHttpService } from '../../services'

import router from '../../router'
export const UpcGeneratorModule = {
    namespaced: true,
    state: {
        data: {
            columns: [
                {
                    label: 'ITEM CODE',
                    field: 'series',
                    sort: 'asc',
                    width: '200'
                },
                {
                    label: 'ITEM NAME',
                    field: 'name',
                    sort: 'asc',
                    clickable: true,
                    width: '350'
                },
                {
                    label: 'UOM',
                    field: 'uom',
                    sort: 'asc',
                    clickable: true,
                    width: '150'
                },
                {
                    label: 'UPC',
                    field: 'serial',
                    sort: 'asc',
                    clickable: true,
                    width: '200'
                },
              
                ],
            rows: [],
        },
        request : null,
        findRequest : null,
        multipleSelection: [],
        newItemDataObject: [],
        length: 100,
        page: 1,
        total: 1,
        searchTerm: null,
        filters: {},
        loading : false,
        postLoading : false,
        findLoading : false,
        form : {},

        initialFormData : {
            reference: 'upc-generator',
            items: [],
        },

        getLoading : false,
        getRecordLoading : false,
        putLoading : false,

        formStatus : 'create',
        
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}
            
        },
        cancelRequest : (state) => {
            state.request.cancel()
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        addFindRequest : (state, req) => {
            state.findRequest = {cancel : req.cancel, msg : "loading"}
            
        },
        cancelFindRequest : (state) => {
            state.findRequest.cancel()
            state.loading = true
        },
        clearOldFindRequest(state, message) {
            state.findRequest.msg = message;
            state.findRequest = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setPostLoadingTrue: (state) => {
            state.postLoading = true
        },
        setPostLoadingFalse: (state) => {
            state.postLoading = false
        },
        setFindLoadingTrue: (state) => {
            state.findLoading = true
        },
        setFindLoadingFalse: (state) => {
            state.findLoading = false
        },
        setColumns(state, payload) {
            state.data.columns = payload
        },
        setRows(state, payload) {
            state.data.rows = payload
        },
        setPage: (state, payload) => {
            state.page = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },
        setLength: (state, payload) => {
            state.length = payload
        },
        setSearchTerm: (state, payload) => {
            state.searchTerm = payload
        },
        setSelection: (state, payload) => {
            state.multipleSelection = payload
        },
        setFilters: (state, payload) => {
            state.filters = payload
        },
        setEmptyData: (state) => {
            state.data.rows = []
        },

        setFormData : (state, payload)=>{

            state.form = payload
        },

        setFormDataItems : (state, payload)=>{
            state.form.items = payload
        },
        setFormRowObject : (state, payload)=>{
            state.form.rowObject = payload
        },
        setNewItemDataObject : (state, payload)=>{
            state.newItemDataObject = payload
        },
        setEmptyForm : (state) => {
            state.form = JSON.parse(JSON.stringify(state.initialFormData))
        },

        setGetloadingTrue(state) {
            state.getLoading = true
        },
        setGetloadingFalse(state) {
            state.getLoading = false
        },
        setTerm: (state, payload) => {
            state.searchTerm = payload
        },

        setPutLoadingTrue : (state) => state.putLoading = true,
        setPutLoadingFalse : (state) => state.putLoading = false,

        setFormStatusCreate : (state) => state.formStatus = 'create',
        setFormStatusUpdate : (state) => state.formStatus = 'update',
        setGetRecordGetLoading : (state,payload) => state.getRecordLoading = payload,
    },
    actions : {
        resetData({dispatch}, endpoint){

        
            return new Promise((resolve, reject) => { 
                dispatch('asyncGetData', endpoint).then((res) => {

                    console.log("reset data")
                    console.log(res)
                    resolve(res)
                }).catch(error => {

                    console.log("reset error")
                    console.log(error)
                    reject(error)
                })
        });
        },
        async asyncGetData({ state, commit},endpoint) {
           
            const { length, page, filters, searchTerm } = state

            return await new Promise((resolve, reject) => {
            
                    commit('setLoading', true)
                    commit('setRows', [])
                    commit('setFormStatusUpdate')
                    const params = { length: length, page: page, term: searchTerm, filters: filters, view : router.app._route.name }

                    const configParams = {
                        req : "UpcGeneratorModule/req",
                        loadingTrue : "UpcGeneratorModule/loadingTrue",
                        addRequest : "UpcGeneratorModule/addRequest",
                        cancelRequest : "UpcGeneratorModule/cancelRequest",
                        clearOldRequest : "UpcGeneratorModule/clearOldRequest"
                    }

                    ApiHttpService.get(endpoint, params, configParams).then((response) => {
                        commit('setRows', response.data.data)
                        commit('setPage',response.data.current_page)
                        commit('setTotal',response.data.total)
                        commit('setLoading', false)
                        resolve(response.data.data)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })
                
            })
        },
        async checkRecord(_,params) {
           

            return await new Promise((resolve, reject) => {
                    ApiHttpService.getRequest('upc-generator/check', params).then((response) => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
      
        async generateUpcCode({ state, commit }, payload) {
            return await new Promise((resolve, reject) => {
                const postLoading = state.postLoading;
                if (!postLoading) {
                    commit('setPostLoadingTrue')
                    const parsePayload = JSON.parse(JSON.stringify(payload))
                    const configParams = {
                        req : "UpcGeneratorModule/req",
                        loadingTrue : "UpcGeneratorModule/setPostLoadingTrue",
                        addRequest : "UpcGeneratorModule/addRequest",
                        cancelRequest : "UpcGeneratorModule/cancelRequest",
                        clearOldRequest : "UpcGeneratorModule/clearOldRequest"
                    }
                    ApiHttpService.post('upc-generator/generate',parsePayload,configParams).then((response) => {
                        commit('setPostLoadingFalse')
                        commit('setNewItemDataObject',response.data)
                        resolve(response.data)
                    }).catch((error) => {
                        commit('setPostLoadingFalse')
                        reject(error)
                    })
                }
            })
        },
    },
    getters: {
        rows: state => state.data.rows,
        data: state => state.data,
        columns: state => state.data.columns,
        selection : state => state.multipleSelection,
        loading : state => state.loading,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        searchTerm: state => state.searchTerm,
        filters: state => state.filters,
        req: state => state.request,
        findRequest: state => state.findRequest,
        form: state => state.form,
        initialFormObject: state => state.initialFormData,
        getLoading: state => state.getLoading,
        formData: state => state.form,
        formStatus: state => state.formStatus,
        putLoading: state => state.putLoading,
        postLoading: state => state.postLoading,
        findLoading: state => state.findLoading,
        getNewItemDataObject: state => state.newItemDataObject,
    }
}



